import { api } from '@/api'
import { PostExcelsRequest } from 'supporter'
import { ncpPopup } from '@/utils/ncp'

/**
 * BE 에서 qs stringify 포멧이 아닌 아래와 같은 포멧으로 넘겨달라 하여 따로 추가한 쿼리스트링 생성하는 재귀함수입니다.
 * https://nickdrane.com/build-your-own-nested-query-string-encoder/
 * 특수한 요구사항이라 jQuery.params, qs.stringify 등 보편적인 메서드로 대체하면 안됩니다.
 *
 * ex )
 * 배열의 경우
 * as-is : saleSettingStatus[types][0]=AVAILABLE_FOR_SALE&saleSettingStatus[types][1]=STOP_SELLING
 * to-be : saleSettingStatus.types=STOP_SELLING&saleSettingStatus.types=PROHIBITION_SALE
 *
 * 중첩 객체의 경우
 * as-is : periodInfo[period][startYmdt]=value
 * to-be : periodInfo.period.startYmdt
 *
 */
function encode(queryObj, nesting = '') {
  const pairs = Object.entries(queryObj).map(([key, val]) => {
    // Handle a second base case where the value to encode is an array
    if (Array.isArray(val)) {
      return val.map((subVal) => [nesting + key, subVal].join('=')).join('&')
    } else if (typeof val === 'object' && val !== null && val !== undefined) {
      return encode(val, nesting + `${key}.`)
    } else {
      // Handle base case, where the value to encode is simply a string.
      return [nesting + key, val].join('=')
    }
  })
  return pairs.join('&')
}

export async function createExcel(
  vueEntity: any,
  hasData: boolean,
  createExcelFileQuery: any,
  menuKey?: string,
  extraInfo?: string
): Promise<any> {
  if (!hasData) return alert(vueEntity.$t('COMMON_NOT_DATA'))

  if (!confirm(vueEntity.$t('EXCEL_DOWNLOAD_CONFIRM_CREATE').toString())) return

  const queryString = encode(createExcelFileQuery)
  let menu = menuKey || vueEntity.$route.meta.excelCreateMenuKey
  const request: PostExcelsRequest = {
    data: {
      queryString: encodeURI(queryString),
      menu,
      extraInfo: extraInfo || null,
    },
  }

  // TODO: 현재 전체주문조회 404
  try {
    await api.postExcels(request)
    ncpPopup('/popup/excel-download', 'EXCEL_DOWNLOAD_LIST', 1000, 800)
    // TODO: 응답오면 사유 post => 파일 다운로드
  } catch (error) {
    console.error(error)
  }
}
